import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import EductorSave from "./EductorSave";
import EductorGetCustomer from "./EductorGetCustomer";

const EductorNew = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });


    //get users
    let response64 = useInvoke("WebApps", "64", {});

    const [users, setUsers] = useState([]);


    useEffect(() => {


        //get user list
        if (response64.data.payload != undefined) {
            let data = JSON.parse(response64.data.payload).data;

            let breakpoint = "";

            let userList = [];

            data.forEach((user, index) => {

                let obj = {
                    "id": user[0],
                    "firstname": user[1],
                    "lastname": user[2],
                    "email": user[3],
                    "mustchangepassword": user[4],
                    "role": user[5]
                };

                userList.push(obj);


            });

            setUsers(userList);


        }

    }, [response64.data.payload]);


    useEffect(() => {

        //re-render page

    }, [users]);


    const handleSaveChanges = (e) => {

        e.preventDefault();

        let edcutorid = "";
        let jobnumber = document.getElementById("jobnumber").value;
        let quotenumber = document.getElementById("quotenumber").value;
        let model = document.getElementById("eductormodel").value;
        let datecompleted = document.getElementById("datecompleted").value;
        let testedbyid = document.getElementById("testedby").value;
        let approvedbyid = document.getElementById("approvedby").value;
        let sketchnumber = document.getElementById("sketchnumber").value;
        let frequency = document.getElementById("hz50").checked ? "50" : "60";
        let inletdiameter = document.getElementById("inletdiameter").value;
        let outletdiameter = document.getElementById("outletdiameter").value;
        let horsepower = document.getElementById("horsepower").value;
        let velocity = document.getElementById("velocity").value;
        let csprinducedairflow = document.getElementById("cspr_inducedairflow").value;
        let csprinletstaticpressure = document.getElementById("cspr_inletstaticpressure").value;
        let csprdischargestaticpressure = document.getElementById("cspr_dischargestaticpressure").value;
        let bsprmanufacturermodel = document.getElementById("bspr_manufacturermodel").value;
        let bsprairflowcfm = document.getElementById("bspr_airflowacfm").value;
        let bsprcalculatedbhp = document.getElementById("bspr_calculatedbhp").value;
        let bsprinletstaticpressure = document.getElementById("bspr_inletstaticpressure").value;
        let bsproutletstaticpressure = document.getElementById("bspr_outletstaticpressure").value;
        let bsprpurchaseordernumber = document.getElementById("bspr_internalpo").value;
        let bsprdatecompleted = document.getElementById("bspr_datecompleted").value;
        let aprplenumpressure = document.getElementById("apr_plenumpressure").value;
        let aprnozzlesetting = document.getElementById("apr_nozzlesetting").value;
        let aprstaticclosedoff = document.getElementById("apr_staticclosedoff").value;
        let aprtight = document.getElementById("apr_tightorloose").value;
        let aprmotorrpm = document.getElementById("apr_motorrpm").value;
        let aprmotorvoltage = document.getElementById("apr_motorvoltage").value;
        let aprcalculatedblowerairflow = document.getElementById("apr_calculatedblowerairflow").value;
        let aprplenumtype = document.getElementById("apr_plenumtype").value;
        let aprmotoramps1 = document.getElementById("apr_motoramps1").value;
        let aprmotoramps2 = document.getElementById("apr_motoramps2").value;
        let aprmotoramps3 = document.getElementById("apr_motoramps3").value;
        let aprmotorampsaverage = document.getElementById("apr_averageamps").value;
        let aprmotorampsrated = document.getElementById("ratedamps").value;
        let notes = document.getElementById("notes").value;
        let air_temperature = document.getElementById("air_temperature").value;
        let air_humidity = document.getElementById("air_humidity").value;
        let air_pressure = document.getElementById("air_pressure").value;
        let intakesilencer = document.getElementById("intakesilencer").value;
        let aprmotornotes = document.getElementById("apr_motornotes").value;
        let suffix = document.getElementById("suffix").value;

        EductorSave(
            edcutorid, jobnumber, quotenumber, model,
            datecompleted, testedbyid, approvedbyid, sketchnumber,
            frequency, inletdiameter, outletdiameter, horsepower,
            velocity, csprinducedairflow, csprinletstaticpressure, csprdischargestaticpressure,
            bsprmanufacturermodel, bsprairflowcfm, bsprcalculatedbhp, bsprinletstaticpressure,
            bsproutletstaticpressure, bsprpurchaseordernumber, bsprdatecompleted,
            aprplenumpressure, aprnozzlesetting, aprstaticclosedoff, aprtight,
            aprmotorrpm, aprmotorvoltage, aprcalculatedblowerairflow, aprplenumtype,
            aprmotoramps1, aprmotoramps2, aprmotoramps3, aprmotorampsaverage,
            aprmotorampsrated, notes, air_temperature, air_humidity, air_pressure, intakesilencer, aprmotornotes, suffix).then((response) => {

                if (response.success) {
                    toast.success("Eductor saved successfully");
                    navigate("/Eductor");
                } else {
                    toast.error("There was an error saving the eductor");
                }
            });

    };

    const handleAmpChange = (e) => {

        let amps1 = parseFloat(document.getElementById("apr_motoramps1").value);
        let amps2 = parseFloat(document.getElementById("apr_motoramps2").value);
        let amps3 = parseFloat(document.getElementById("apr_motoramps3").value);
        let rated = parseFloat(document.getElementById("ratedamps").value);
        let ampsavg = (parseFloat(amps1) + parseFloat(amps2) + parseFloat(amps3)) / 3;

        // For amps1
        if (amps1 < rated && amps1 > rated * 0.95) {
            document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (amps1 >= rated) {
            document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_motoramps1").style.backgroundColor = "unset";
        }

        // For amps2
        if (amps2 < rated && amps2 > rated * 0.95) {
            document.getElementById("apr_motoramps2").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (amps2 >= rated) {
            document.getElementById("apr_motoramps2").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_motoramps2").style.backgroundColor = "unset";
        }

        // For amps3
        if (amps3 < rated && amps3 > rated * 0.95) {
            document.getElementById("apr_motoramps3").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (amps3 >= rated) {
            document.getElementById("apr_motoramps3").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_motoramps3").style.backgroundColor = "unset";
        }

        // For apr_averageamps
        if (ampsavg < rated && ampsavg > rated * 0.95) {
            document.getElementById("apr_averageamps").style.backgroundColor = "rgba(255, 165, 0, 0.2)";
        } else if (ampsavg >= rated) {
            document.getElementById("apr_averageamps").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
        } else {
            document.getElementById("apr_averageamps").style.backgroundColor = "unset";
        }

        document.getElementById("apr_averageamps").value = ampsavg.toFixed(2);

    };

    const handleRatedChange = (e) => {

        document.getElementById("apr_ratedamps").value = document.getElementById("ratedamps").value;

        handleAmpChange();

    };

    const handleQuoteNumberChange = (e) => {

        EductorGetCustomer(e.target.value).then((response) => {
            if (response.success && JSON.parse(response.payload).data.length > 0) {
                document.getElementById("customer").value = JSON.parse(response.payload).data[0][0];
                document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
            }
            else {
                document.getElementById("customer").value = "";
                document.getElementById("apr_motoramps1").style.backgroundColor = "rgba(255, 0, 0, 0.2)";
            }
        });

    };

    document.title = `Eductor New`;
    return (
        <div className="eductors">
            {user["email"] != undefined &&

                <>
                    <div className="container" style={{ margin: "auto" }}>



                        <div className="card border-secondary mb-3" style={{ fontSize: "18px", fontWeight: "bold" }}>

                            <div style={{ display: "flex", flexDirection: "row", margin: "8px", justifyContent: "space-between" }}>

                                <Link to="/Eductor" className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Return to Eductors</Link>
                                {/* <button onClick={handleFormSubmit} className="btn btn-success" style={{marginRight: "4px", width: "auto"}}>Save</button> */}

                            </div>

                            {/* <div style={{color: "var(--bs-green)", fontSize: "22px"}} className="card-header">Eductor Details</div> */}

                            <div className="card-body">

                                <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-green)", marginTop: "16px" }}>Model Information</h4>


                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>

                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px" }}>
                                        <span style={{ color: "var(--bs-secondary)" }}>Eductor Model Name </span>
                                        <i style={{ opacity: "0.5" }}>(ED - &#123;INLET&#125; X &#123;OUTLET&#125; - &#123;HORSEPOWER&#125;HP) Example: <span style={{ textDecoration: "underline" }}>ED - 6 X 8 - 5HP</span></i>
                                    </div>
                                    
                                    <input className="form-control" id="eductormodel" name="eductormodel" type="text" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                </div>

                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="suffix">Model (Ext.)</label>
                                    <input className="form-control" id="suffix" name="suffix" type="text" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                </div>

                                <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                    <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_manufacturermodel">Fan Model Name</label>
                                    <input className="form-control" id="bspr_manufacturermodel" name="bspr_manufacturermodel" type="text" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                </div>



                                <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-green)", marginTop: "16px" }}>Job Data</h4>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="jobnumber">Job Number</label>
                                        <input className="form-control" id="jobnumber" name="jobnumber" type="text" readOnly={false} autoComplete="off" />
                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="quotenumber">Quote Number</label>
                                        <input onChange={(e) => { handleQuoteNumberChange(e) }} className="form-control" id="quotenumber" name="quotenumber" type="text" readOnly={false} autoComplete="off" />
                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="sketchnumber">Sketch Number</label>
                                        <input className="form-control" id="sketchnumber" name="sketchnumber" type="text" readOnly={false} autoComplete="off" />
                                    </div>





                                </div>

                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "33%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="customer">Customer</label>
                                        <input onClick={() => { toast("Derived from Quote Number", { icon: "💡" }) }} className="form-control" id="customer" name="customer" type="text" readOnly={true} autoComplete="off" />
                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", marginTop: "8px", width: "33%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_internalpo">Internal PO / Routing</label>
                                        <input className="form-control" id="bspr_internalpo" name="bspr_internalpo" type="text" readOnly={false} autoComplete="off" />
                                    </div>

                                </div>



                                <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-green)", marginTop: "16px" }}>Technical Specifications</h4>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="inletdiameter">Inlet Diameter (in)</label>
                                        <input className="form-control" id="inletdiameter" name="inletdiameter" type="number" readOnly={false} autoComplete="off" />
                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="outletdiameter">Outlet Diameter (in)</label>
                                        <input className="form-control" id="outletdiameter" name="outletdiameter" type="number" readOnly={false} autoComplete="off" />
                                    </div>



                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="velocity">Velocity</label>
                                        <input className="form-control" id="velocity" name="velocity" type="number" readOnly={false} autoComplete="off" />
                                    </div>

                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="ratedamps">Rated Amps</label>
                                        <input onChange={() => { handleRatedChange() }} className="form-control" id="ratedamps" name="ratedamps" type="number" readOnly={false} autoComplete="off" />
                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="horsepower">Horsepower</label>
                                        <input className="form-control" id="horsepower" name="horsepower" type="number" readOnly={false} autoComplete="off" />
                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="frequency">Frequency</label>
                                        <div className="form-group" id="frequency" name="frequency" style={{ display: "flex", flexDirection: "row", margin: "8px", width: "50%", minWidth: "128px" }}>

                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="hz" id="hz50" value="50" />
                                                <label className="form-check-label" htmlFor="hz">50 hz</label>
                                            </div>

                                            <div className="form-check" style={{ marginLeft: "16px" }}>
                                                <input className="form-check-input" type="radio" name="hz" id="hz60" value="60" defaultChecked={true} />
                                                <label className="form-check-label" htmlFor="hz">60 hz</label>
                                            </div>

                                        </div>
                                    </div>

                                </div>

                                <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-green)", marginTop: "16px" }}>Test Information</h4>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="testedby">Tested By</label>

                                        {users.length > 0 &&
                                            <>
                                                <select id="testedby" className="form-control"
                                                    style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                    <option value="">Select User</option>
                                                    {
                                                        users.map((u, index) => (
                                                            <option key={index} value={u["id"]}>{`${u["firstname"]} ${u["lastname"]} - ${u["email"]}`}</option>
                                                        ))
                                                    }

                                                </select>

                                            </>
                                        }


                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="approvedby">Approved By</label>

                                        {users.length > 0 &&
                                            <>
                                                <select id="approvedby" className="form-control"
                                                    style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                    <option value="">Select User</option>
                                                    {
                                                        users.map((u, index) => (
                                                            <option key={index} value={u["id"]}>{`${u["firstname"]} ${u["lastname"]} - ${u["email"]}`}</option>
                                                        ))
                                                    }

                                                </select>

                                            </>
                                        }

                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="datecompleted">Date Completed</label>
                                        <input className="form-control" id="datecompleted" name="datecompleted" type="date" readOnly={false} autoComplete="off" />
                                    </div>




                                </div>

                                <h4 className="card-title" style={{ fontWeight: "bold", color: "var(--bs-green)", marginTop: "16px" }}>Air Properties During Test</h4>
                                <Link to="https://www.wunderground.com/history" style={{ fontSize: "14px", textDecoration: "underline", color: "var(--bs-teal)", marginLeft: "8px" }}>Historical Weather Data</Link>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_temperature">Temperature (°F)</label>

                                        <input className="form-control" id="air_temperature" name="air_temperature" type="number" readOnly={false} autoComplete="off" />

                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_humidity">Humidity (%)</label>

                                        <input className="form-control" id="air_humidity" name="air_humidity" type="number" readOnly={false} autoComplete="off" />

                                    </div>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="air_pressure">Air Pressure (inHg)</label>

                                        <input className="form-control" id="air_pressure" name="air_pressure" type="number" readOnly={false} autoComplete="off" />

                                    </div>

                                </div>

                                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>

                                    <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "100%", minWidth: "128px" }}>
                                        <label style={{ color: "var(--bs-secondary)" }} htmlFor="notes">Notes</label>
                                        <textarea rows="5" className="form-control" id="notes" name="notes" type="text" readOnly={false} autoComplete="off" style={{ color: "var(--bs-secondary)", minWidth: "100%" }} />
                                    </div>

                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                        <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-green)" }}>Calculated System Performance</h4>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="cspr_inducedairflow">A) Induced Airflow</label>
                                            <input className="form-control" id="cspr_inducedairflow" name="cspr_inducedairflow" type="number" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                        </div>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="cspr_inletstaticpressure">B) Inlet Static Pressure</label>
                                            <input className="form-control" id="cspr_inletstaticpressure" name="cspr_inletstaticpressure" type="number" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                        </div>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "96%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="cspr_dischargestaticpressure">C) Discharge Static Pressure</label>
                                            <input className="form-control" id="cspr_dischargestaticpressure" name="cspr_dischargestaticpressure" type="number" readOnly={false} autoComplete="off" style={{ minWidth: "100%" }} />
                                        </div>

                                    </div>

                                    <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                        <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-green)" }}>Blower Selection Performance Requirements</h4>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_airflowacfm">Airflow (ACFM)</label>
                                                <input className="form-control" id="bspr_airflowacfm" name="bspr_airflowacfm" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_calculatedbhp">Calculated BHP</label>
                                                <input className="form-control" id="bspr_calculatedbhp" name="bspr_calculatedbhp" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_inletstaticpressure">Inlet Static Pressure</label>
                                                <input className="form-control" id="bspr_inletstaticpressure" name="bspr_inletstaticpressure" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_outletstaticpressure">Outlet Static Pressure</label>
                                                <input className="form-control" id="bspr_outletstaticpressure" name="bspr_outletstaticpressure" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>



                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="bspr_datecompleted">Date Completed</label>
                                                <input className="form-control" id="bspr_datecompleted" name="bspr_datecompleted" type="date" readOnly={false} autoComplete="off" />
                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div style={{ display: "flex", flexDirection: "row" }}>

                                    <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                        <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-green)" }}>Actual Performance Results</h4>



                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_plenumpressure">Actual Plenum Pressure</label>
                                                <input className="form-control" id="apr_plenumpressure" name="apr_plenumpressure" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_plenumtype">Plenum Type</label>
                                                <select id="apr_plenumtype" className="form-control"
                                                    style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                    <option value="">Select Plenum Type</option>
                                                    <option value="Winged">Winged</option>
                                                    <option value="Straight">Straight</option>

                                                </select>
                                            </div>



                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_staticclosedoff">Static Closed Off</label>
                                                <input className="form-control" id="apr_staticclosedoff" name="apr_staticclosedoff" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_tightorloose">Nozzle Tightness</label>
                                                <select id="apr_tightorloose" className="form-control"
                                                    style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                    <option value="">Select Tightness</option>
                                                    <option value="Tight">Tight</option>
                                                    <option value="Loose">Loose</option>

                                                </select>
                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_calculatedblowerairflow">Calculated Air Flow (ACFM)</label>
                                                <input className="form-control" id="apr_calculatedblowerairflow" name="apr_calculatedblowerairflow" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_nozzlesetting">Nozzle Setting</label>
                                                <select id="apr_nozzlesetting" className="form-select"
                                                    style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>

                                                    <option value="">Select Nozzle</option>
                                                    <option value="None">None</option>
                                                    <option value="Loose">Loose</option>
                                                    <option value="11/32">11/32"</option>
                                                    <option value="7/16">7/16"</option>
                                                    <option value="1/2">1/2"</option>
                                                    <option value="9/16">9/16"</option>
                                                    <option value="5/8">5/8"</option>
                                                    <option value="11/16">11/16"</option>
                                                    <option value="3/4">3/4"</option>
                                                    <option value="13/16">13/16"</option>
                                                    <option value="7/8">7/8"</option>
                                                    <option value="15/16">15/16"</option>
                                                    <option value="1">1"</option>

                                                </select>

                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motorrpm">Motor RPM</label>
                                                <input className="form-control" id="apr_motorrpm" name="apr_motorrpm" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>

                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="intakesilencer">Intake Silencer</label>
                                                <select id="intakesilencer" defaultValue={""} className="form-control"
                                                    style={{ fontSize: "14px", color: "#555555", padding: "7px 12px", border: "1px solid #e7e7e7", borderRadius: "4px", boxShadow: "inset 0px 2px 0px rgba(0, 0, 0, 0.075)" }}>
                                                    <option value="">Select Option</option>
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>

                                                </select>

                                            </div>

                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motorvoltage">Motor Voltage (v)</label>
                                                <input className="form-control" id="apr_motorvoltage" name="apr_motorvoltage" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                        </div>

                                    </div>

                                    <div className="card border-light mb-3" style={{ display: "flex", flexDirection: "column", width: "48%", margin: "1%" }}>
                                        <h4 className="card-header" style={{ marginTop: "-4px", fontWeight: "bold", padding: "8px", color: "var(--bs-green)" }}>Motor Amps</h4>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>

                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motoramps1">1) Amps</label>
                                                <input onChange={() => { handleAmpChange() }} className="form-control" id="apr_motoramps1" name="apr_motoramps1" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_ratedamps">Rated Amps</label>
                                                <input onClick={() => { toast("This field is modified above", { icon: "💡" }) }} className="form-control" id="apr_ratedamps" name="apr_ratedamps" type="number" readOnly={true} autoComplete="off" />
                                            </div>



                                        </div>

                                        <div style={{ display: "flex", flexDirection: "row" }}>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motoramps2">2) Amps</label>
                                                <input onChange={() => { handleAmpChange() }} className="form-control" id="apr_motoramps2" name="apr_motoramps2" type="number" readOnly={false} autoComplete="off" />
                                            </div>

                                            <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                                <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_averageamps">Average Amps</label>
                                                <input className="form-control" id="apr_averageamps" name="apr_averageamps" type="number" readOnly={true} autoComplete="off" />
                                            </div>

                                        </div>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "50%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motoramps3">3) Amps</label>
                                            <input onChange={() => { handleAmpChange() }} className="form-control" id="apr_motoramps3" name="apr_motoramps3" type="number" readOnly={false} autoComplete="off" />
                                        </div>

                                        <div className="form-group" style={{ display: "flex", flexDirection: "column", margin: "8px", width: "100%", minWidth: "128px" }}>
                                            <label style={{ color: "var(--bs-secondary)" }} htmlFor="apr_motornotes">Motor Notes</label>
                                            <textarea rows="5" className="form-control" id="apr_motornotes" name="apr_motornotes" type="text" readOnly={false} autoComplete="off" style={{ color: "var(--bs-secondary)", minWidth: "100%" }} />
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <div style={{ display: "flex", flexDirection: "row", margin: "8px", justifyContent: "flex-end" }}>

                                <button onClick={handleSaveChanges} className="btn btn-success" style={{ marginRight: "4px", width: "auto" }}>Submit</button>

                            </div>

                        </div>



                    </div>

                </>

            }

        </div>
    );
}

export default EductorNew;